<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-12 p-0 companies-section">
    <!-- <app-header></app-header> -->
    <div class="col-height">

      <div class="profile-layout">
        {{data}}
      </div>




    </div>
  </div>
</div>
